import { EscrowStatusEnum, type ISoftwareEscrow, type IContinuityEscrow, type ISaasEscrow } from 'src/graphql/schema';

type IEscrow = ISoftwareEscrow | IContinuityEscrow | ISaasEscrow;

export function shouldCurrentPartyConfigureEscrow(softwareEscrow: IEscrow): boolean {
  const { currentCompanyRole, status } = softwareEscrow;
  const isCurrentPartyConfigured = softwareEscrow[`${currentCompanyRole!}Configured`];
  const canUpdateEscrow = softwareEscrow[currentCompanyRole!]?.policy.update;

  return (!isCurrentPartyConfigured && status === EscrowStatusEnum.Onboarding && canUpdateEscrow) || false;
}
